const initObj = {
  viewPortWidth: 0,
  viewPortHeight: 0,
  isMobileMenuActive: false,
  isMobileSubActive: false,
  isAnnouncementActive: false,
}

export default initObj
